(function() {
    'use strict';

    angular.module('GorillaBoy.AdminWD')
    .controller('AdminWDController', [
        '$scope',
        '$log',
        'SourceConstant',
        AdminWDController
    ]);

    function AdminWDController($scope, $log, SourceConstant) {
        $scope.layout = {
            partialContent: './admin/workdrives/content_partial.html',
            partialTitleBar: './admin/workdrives/title_bar.html'
        };
    }
}());